<template>
        <a-modal
                title="标题"
                okText="确认"
                cancelText="取消"
                width="500px"
                :visible="visible"
                :confirm-loading="confirmLoading"
                @ok="handleOk"
                @cancel="handleCancel"
        >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
            <a-row>
                <a-col span="12">
                    <a-form-model-item label="字段2" prop="name">
                        <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.name" />
                    </a-form-model-item>
                </a-col>
                <a-col span="12">
                    <a-form-model-item label="字段2" prop="code">
                        <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.code" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col span="12">
                    <a-form-model-item label="字段2" prop="xzqh">
                        <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.xzqh" />
                    </a-form-model-item>
                </a-col>
                <a-col span="12">
                    <a-form-model-item label="字段2" prop="bossName">
                        <a-input  placeholder="请输入密码333" autocomplete="off" v-model="form.bossName" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
        <return-model v-if="returnModalVisable" :visible.sync="returnModalVisable" @returnModalClose="onReturnModalClose"></return-model>
        </a-modal>
</template>

<script>
    import AExtUpload from '../../../components/AntDesignExt/Demo/AExtUpload'
    import ReturnModel from './ReturnModel'
    import {addorUpdateOChecker as saveApi,getOCheckerById as initApi} from '../../../api/api'

    export default {
        name: "FormModel",
        components:{AExtUpload,ReturnModel},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            param:{
                type:Object,
                default: ()=>{
                    return {}
                }
            }
        },
        data() {
            return {
                confirmLoading: false,
                form: {
                    name: '',
                    code: '',
                    xzqh: '',
                    bossName: ''
                },
                rules: {
                    name: [{required: true, message: '请输入文本框内容', trigger: 'blur'},],
                    code: [{required: true, message: '请输入文本框内容', trigger: 'blur'},],
                    xzqh: [{required: true, message: '请输入文本框内容', trigger: 'blur'},],
                    bossName: [{required: true, message: '请输入文本框内容', trigger: 'blur'},],
                },
                returnModalVisable:false,
                returnModalBackChange:null,
                returnModalParam:null
            };
        },
        created(){
            this.initForm();
        },
        methods: {
            initForm(){
                if(this.param.id) {
                    this.confirmLoading = true;
                    initApi(this.param).then((result => {
                        this.form = result.data.data;
                        this.confirmLoading = false;
                    })).catch(() => {
                        this.confirmLoading = false;
                    });
                }
            },
            handleOk(e) {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.confirmLoading = true;
                        saveApi(this.form).then((result=>{
                            this.confirmLoading = false;
                            this.$emit("addModalClose",true)
                            this.$emit("update:visible",false)
                        })).catch(()=>{
                            this.confirmLoading = false;
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleCancel(e) {
                this.$emit("update:visible",false)
            },
            showReturnModal(record){
                this.returnModalParam={}
                this.returnModalVisable=true;
            },
            onReturnModalClose(data)
            {
                // alert(JSON.stringify(data))
            },
        },
    }
</script>

<style scoped lang="scss">

    /deep/ .ant-modal-body{
        /*height: 70vh;*/
        /*overflow-y: scroll;*/
    }

</style>